import API from "../../api";
import { API_REGISTER_TREATMENT} from "../../constants/api";

const getInformationTreatment = async (inspectionId) => {
  try {
    const response = await API.get(API_REGISTER_TREATMENT(inspectionId));
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const register = async (inspectionId, data) => {
  try {
    const response = await API.post(API_REGISTER_TREATMENT(inspectionId), data);
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const RegisterTreatment = {
  getInformationTreatment,
  register
};

export {
  RegisterTreatment as default,
  getInformationTreatment,
  register
}